<template>
  <div class="container dashboard">
    <div class="top">
      <div class="total-card card"
           :style="{'width':cardWidth}"> 
        <img src="@/assets/img/home_order.png"
             class="icon" />
        <div class="total-card-text">
          <span>今日订单总数</span>
          <span>{{todayOrder.order_count || 0}}</span>
        </div>
      </div>
      <div class="total-card card"
           :style="{'width':cardWidth}"> <img src="@/assets/img/home_today_amount.png"
             class="icon" />
        <div class="total-card-text">
          <span>今日订单金额</span>
          <span>￥{{todayOrder.order_amount || '0.00'}}</span>
        </div>
      </div>
      <div class="total-card card"
           :style="{'width':cardWidth}"> <img src="@/assets/img/home_order.png"
             class="icon" />
        <div class="total-card-text">
          <span>本月订单总数</span>
          <span>{{monthOrder.order_count || 0}}</span>
        </div>
      </div>
      <div class="total-card card"
           :style="{'width':cardWidth}"> <img src="@/assets/img/home_yesterday_amount.png"
             class="icon" />
        <div class="total-card-text">
          <span>本月订单金额</span>
          <span>￥{{monthOrder.order_amount || 0}}</span>
        </div>
      </div>
    </div>
    <div class="center card">
      <div class="layout-title">待处理事务</div>
      <div class="warp">
        <div class="warp-item"
             :style="{'width':centerWidth}">
          <div class="item-text">
            <span>待付款订单</span>
            <span>(0)</span>
          </div>
          <div class="item-text">
            <span>待发货订单</span>
            <span>(0)</span>
          </div>
          <div class="item-text">
            <span>已发货订单</span>
            <span>(0)</span>
          </div>
        </div>
        <div class="warp-item"
             :style="{'width':centerWidth}">
          <div class="item-text">
            <span>已完成订单</span>
            <span>(0)</span>
          </div>
          <div class="item-text">
            <span>新缺货登记</span>
            <span>(0)</span>
          </div>
          <div class="item-text">
            <span>待处理退货订单</span>
            <span>(0)</span>
          </div>
        </div>
        <div class="warp-item"
             :style="{'width':centerWidth}">
          <div class="item-text">
            <span>待确认收货订单</span>
            <span>(0)</span>
          </div>
          <div class="item-text">
            <span>待处理退款申请</span>
            <span>(0)</span>
          </div>
          <div class="item-text">
            <span>广告位即将到期</span>
            <span>(0)</span>
          </div>
        </div>
      </div>
    </div>
    <div class="center card">
      <div class="layout-title">商品统计</div>
      <div class="warp">
        <div class="warp-item warp-item-other"
             :style="{'width':thirdWidth}">
          <div class="item-text">
            <span>已上线文章</span>
            <span>({{this.productCount.article_online_count || 0}})</span>
          </div>
          <div class="item-text">
            <span>已下线文章</span>
            <span>({{this.productCount.article_count-this.productCount.article_online_count}})</span>
          </div>
          <div class="item-text">
            <span>全部文章</span>
            <span>({{this.productCount.article_count || 0}})</span>
          </div>
        </div>
        <div class="warp-item warp-item-other"
             :style="{'width':thirdWidth}">
          <div class="item-text">
            <span>已上线课程</span>
            <span>({{this.productCount.course_online_count || 0}})</span>
          </div>
          <div class="item-text">
            <span>已下线课程</span>
            <span>({{this.productCount.course_count-this.productCount.course_online_count}})</span>
          </div>
          <div class="item-text">
            <span>全部课程</span>
            <span>({{this.productCount.course_count || 0}})</span>
          </div>
        </div>
        <div class="warp-item warp-item-other"
             :style="{'width':thirdWidth}">
          <div class="item-text">
            <span>已上线题库</span>
            <span>({{this.productCount.exam_online_count || 0}})</span>
          </div>
          <div class="item-text">
            <span>已下线题库</span>
            <span>({{this.productCount.exam_count-this.productCount.exam_online_count}})</span>
          </div>
          <div class="item-text">
            <span>全部题库</span>
            <span>({{this.productCount.exam_count || 0}})</span>
          </div>
        </div>
        <div class="warp-item warp-item-other"
             :style="{'width':thirdWidth}">
          <div class="item-text">
            <span>已上线材料</span>
            <span>({{this.productCount.material_online_count || 0}})</span>
          </div>
          <div class="item-text">
            <span>已下线材料</span>
            <span>({{this.productCount.material_count-this.productCount.material_online_count}})</span>
          </div>
          <div class="item-text">
            <span>全部材料</span>
            <span>({{this.productCount.material_count || 0}})</span>
          </div>
        </div>
        <div class="warp-item warp-item-other"
             :style="{'width':thirdWidth}">
          <div class="item-text">
            <span>已上线阅读资料</span>
            <span>({{this.productCount.read_online_count || 0}})</span>
          </div>
          <div class="item-text">
            <span>已下线阅读资料</span>
            <span>({{this.productCount.read_count-this.productCount.read_online_count}})</span>
          </div>
          <div class="item-text">
            <span>全部阅读资料</span>
            <span>({{this.productCount.read_count || 0}})</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="out-border card"
           :style="{'width':outBorderWidth}">
        <div class="layout-title">用户总览</div>
        <div class="out-wrap">
          <div class="out-item">
            <span>{{todayUser.user_count || 0}}</span>
            <span>今日新增</span>
          </div>
          <div class="out-item">
            <span>{{yesterUser.user_count || 0}}</span>
            <span>昨日新增</span>
          </div>
          <div class="out-item">
            <span>{{monthUser.user_count || 0}}</span>
            <span>本月新增</span>
          </div>
          <div class="out-item">
            <span>{{totalUser.user_count|| 0}}</span>
            <span>用户总数</span>
          </div>
        </div>
      </div>
      <div class="out-border card"
           :style="{'width':outBorderWidth}">
        <div class="layout-title">学长总览</div>
        <div class="out-wrap">
          <div class="out-item">
            <span>{{todaySenior.senior_count || 0}}</span>
            <span>今日新增</span>
          </div>
          <div class="out-item">
            <span>{{yesterSenior.senior_count || 0}}</span>
            <span>昨日新增</span>
          </div>
          <div class="out-item">
            <span>{{monthSenior.senior_count || 0}}</span>
            <span>本月新增</span>
          </div>
          <div class="out-item">
            <span>{{totalSenior.senior_count|| 0}}</span>
            <span>学长总数</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { productCount, seniorCount, memberCount, orderCount } from '@/api/count'
export default {
  name: 'home',
  data() {
    return {
      todayOrder: {},
      monthOrder: {},
      yesterOrder: {},
      weekOrder: {},
      productCount: {},
      todayUser: {},
      yesterUser: {},
      monthUser: {},
      totalUser: {},
      todaySenior: {},
      yesterSenior: {},
      monthSenior: {},
      totalSenior: {},
      cardWidth: document.body.clientWidth < 820 ? '100%' : '23%',
      centerWidth: document.body.clientWidth < 820 ? '100%' : '30%',
      thirdWidth: document.body.clientWidth < 820 ? '100%' : '19%',
      outBorderWidth: document.body.clientWidth < 820 ? '100%' : '49%',
    }
  },
  created() {
    this.fetchOrderCount()
    this.fetchProductCount()
    this.fetchMemberCount()
    this.fetchSeniorCount()
  },
  methods: {
    // 订单数据
    fetchOrderCount() {
      const todayStart = this.$moment().startOf('day').valueOf()
      const todayEnd = this.$moment().endOf('day').valueOf()
      const monthStart = this.$moment().startOf('month').valueOf()
      const monthEnd = this.$moment().endOf('month').valueOf()

      Promise.all([
        orderCount({ startTime: todayStart, endTime: todayEnd }),
        orderCount({ startTime: monthStart, endTime: monthEnd }),
      ]).then((res) => {
        this.todayOrder = res[0]
        this.monthOrder = res[1]
      })
    },
    // 内容数据
    fetchProductCount() {
      let today = this.$moment().valueOf()
      productCount().then((res) => {
        this.productCount = res
      })
    },
    // 用户数据
    fetchMemberCount() {
      let todayStart = this.$moment().startOf('day').valueOf()
      let today = this.$moment().valueOf()
      let yesterStart = this.$moment()
        .subtract(1, 'day')
        .startOf('day')
        .valueOf()
      let yesterEnd = this.$moment().subtract(1, 'day').endOf('day').valueOf()
      let monthStart = this.$moment().startOf('month').valueOf()
      Promise.all([
        memberCount({ startTime: todayStart, endTime: today }),
        memberCount({ startTime: yesterStart, endTime: yesterEnd }),
        memberCount({ startTime: monthStart, endTime: today }),
        memberCount(),
      ]).then((res) => {
        this.todayUser = res[0]
        this.yesterUser = res[1]
        this.monthUser = res[2]
        this.totalUser = res[3]
      })
    },
    // 学长数据
    fetchSeniorCount() {
      let todayStart = this.$moment().startOf('day').valueOf()
      let today = this.$moment().valueOf()
      let yesterStart = this.$moment()
        .subtract(1, 'day')
        .startOf('day')
        .valueOf()
      let yesterEnd = this.$moment().subtract(1, 'day').endOf('day').valueOf()
      let monthStart = this.$moment().startOf('month').valueOf()
      Promise.all([
        seniorCount({ startTime: todayStart, endTime: today }),
        seniorCount({ startTime: yesterStart, endTime: yesterEnd }),
        seniorCount({ startTime: monthStart, endTime: today }),
        seniorCount(),
      ]).then((res) => {
        this.todaySenior = res[0]
        this.yesterSenior = res[1]
        this.monthSenior = res[2]
        this.totalSenior = res[3]
      })
    },
  },
}
</script>

<style scoped lang="less">
.dashboard {
  .card {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
  }
  .top {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .total-frame {
      background: #fff;
      border: 1px solid #dcdfe6;
    }
    .total-card {
      position: relative;
      height: 100px;
      padding: 20px;
      display: flex;
      background-color: #fff;
      margin-bottom: 8px;
      .icon {
        color: #409eff;
        width: 60px;
        height: 60px;
      }
      .total-card-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        padding: 0px 16px;
        justify-content: space-around;
        :nth-child(1) {
          font-size: 16px;
          color: #909399;
        }
        :nth-child(2) {
          font-size: 18px;
          color: #606266;
        }
      }
    }
  }
  .center {
    margin-bottom: 8px;
    background: #fff;
    border: 1px solid #dcdfe6;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .out-border {
      background: #fff;
      border: 1px solid #dcdfe6;
      width: 820px;
      margin-bottom: 8px;
    }
    .out-wrap {
      padding: 16px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .out-item {
        width: 140px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 0px;
        :nth-child(1) {
          color: #f56c6c;
          font-size: 24px;
          margin-bottom: 8px;
        }
      }
    }
  }
  .layout-title {
    color: #606266;
    padding: 15px 20px;
    background: #f2f6fc;
    font-weight: bold;
  }
  .warp {
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .warp-item {
    width: 540px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .item-text {
      padding: 10px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ebeef5;
      :nth-child(1) {
        font-size: 14px;
      }
      :nth-child(2) {
        font-size: 14px;
        color: #f56c6c;
      }
    }
  }
  .warp-item-other {
    width: 300px;
  }
  .overview-layout {
    margin-top: 20px;
  }
  .overview-item-value {
    font-size: 24px;
    text-align: center;
  }
  .overview-item-title {
    margin-top: 10px;
    text-align: center;
  }
  .color-danger {
    color: #f56c6c;
  }
}
</style>
